<template>
  <div class="page--full submitted">
    <div class="success__wrapper">
      <img src="@/assets/images/submitted/email-sent.svg" alt="" />
      <h1 class="header__wrapper"><span class="header">Thank You!</span></h1>
      <p class="subheader">Your email was sent to us. We will be in touch.</p>
    </div>
    <p class="back hidden-sm-and-up" @click="$router.push('/#home')">
      <span>Back to homepage</span>
      <img src="@/assets/images/submitted/next-black.svg" alt="" />
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.submitted {
  padding: 9.25rem 2.5rem 0;
  @media (min-width: $sm) {
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.header {
  &__wrapper {
    margin-bottom: 0;
  }
}

.subheader {
  color: $color-secondary;
  font-size: 0.875rem;
  font-weight: 400;
  opacity: 0.5;
  @media (min-width: $sm) {
    font-size: 1.25rem;
  }
  a {
    color: $color-secondary;
    text-decoration: none;
    border-bottom: 1px solid $color-secondary;
  }
}

.back {
  position: absolute;
  bottom: 5%;
  left: 50%;
  transform: translate(-50%);
  font-size: 1.25rem;
  font-weight: 600;
  span {
    padding-right: 0.5rem;
    vertical-align: middle;
  }
  img {
    vertical-align: middle;
  }
}
</style>
